import PrefixPath from './AppConfig';

// Per-environment version, set as `appVersion` in src/config/EnvironmentConfig.js.
export const APP_VERSION = PrefixPath.APP_VERSION || '0.0.0';

export function formatVersionFooter() {
  return `v${APP_VERSION}`;
}
